export default Object.freeze({
    OFFER: 'OFFER',
    REVENUE: 'REVENUE',
    CUSTOM_RESERVATION_PRICE: 'CUSTOM_RESERVATION_PRICE',
    CUSTOM_RESERVATION_SEND: 'CUSTOM_RESERVATION_SEND',
})
